import { JsonObject, JsonProperty } from 'json2typescript';
import { EditClientDataInterface } from '../interfaces/edit-client-data.interface';

@JsonObject('EditClientData')
export class EditClientData implements EditClientDataInterface {
  AcceptEmailMarketing?: boolean;
  AcceptMarketing?: boolean;
  AddittionalFiscalCountries?: any;
  AdvisorCode?: any;
  AdvisorFullName?: any;
  Agent?: Agent;
  AssetLiabilities2Y?: number;
  BirthDate?: string;
  BranchCode?: any;
  Citizenship?: string;
  CityOfBirth?: string;
  ClientCode?: string;
  Code?: string;
  ConvenienceGroups?: string;
  CountRecordator?: number;
  CountryOfBirth?: string;
  CountryOfResidence?: string;
  Currency?: any;
  CurrentEquityAsset?: number;
  CurrentAssetLiabilities?: number;
  Date_last_test?: string;
  DisclaimerOnboardingChecked?: boolean;
  DocExpirationDate?: string;
  DocExpirationDatePermanent?: boolean;
  DocId?: string;
  DocType?: string;
  Email?: string;
  EquityAsset2Y?: number;
  ExpirationDateLegalEntityId?: string;
  FATCACRSData?: any;
  Gender?: string;
  HabitualResidence?: HabitualResidence;
  HasCredentials?: boolean;
  Id?: string;
  IdDocumentNumber?: any;
  IsDifferentMailAddress?: boolean;
  IsFavourite?: boolean;
  IsForeigner?: boolean;
  IsPotential?: boolean;
  IsResident?: boolean;
  IssuingCountry?: string;
  IsSuitable?: boolean;
  KnowledgeLevel?: string;
  LandLine?: string;
  Language?: string;
  LegalEntityId?: any;
  LegalGuardian_contract_relation?: string;
  LegalGuardians?: any[];
  LegalGuardianType?: string;
  MailResidence?: MailResidence;
  MaritalStatus?: string;
  Mifi2Category?: string;
  Mifi2CategoryCode?: string;
  Mifid_competence?: string;
  Mifid_competenceName?: string;
  Name?: string;
  Nature?: string;
  NatureId?: any;
  NumDependants?: number;
  OnboardingInProcess?: number;
  OnboardingStatus?: string;
  Owner?: any;
  Password?: any;
  PerformancePublicDuties?: PerformancePublicDuties;
  Phone?: string;
  Phone2?: string;
  ProfessionalData?: ProfessionalData;
  ProfileId?: number;
  ProfileName?: string;
  ProfileTestSignatureStatus?: any;
  ProfileTestSignatureType?: any;
  QuestionnarieTypes?: any;
  ReferenciaPerfil?: any;
  RegistredCountry?: string;
  Saludation?: string;
  SegmentCode?: any;
  SegmentName?: any;
  ServiceModelCode?: any;
  ServicioAsesoramientoActivado?: boolean;
  Status?: any;
  Surname?: string;
  TaxResidence?: TaxResidence;
  TotalBalance?: number;
  TradesPerYear?: string;
  Type?: string;
  TypeId?: any;
  TypeService?: any;
  ValidateDocExpirationDate?: number;
  ValidatePortfolioOnboardingStatus?: boolean;
  W8Ben?: W8Ben;
  YearsTrading?: string;
  Documents?: Documents[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AgentEditClient')
export class Agent {
  Code?: string;
  Email?: string;
  FullName?: string;
  Phone?: string;
  UserCode?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('HabitualResidenceEditClient')
export class HabitualResidence {
  City?: string;
  CityOfBirth?: any;
  Country?: string;
  CountryPersonal?: any;
  DireccionFiscal?: any;
  DireccionFiscalCiudad?: any;
  DireccionFiscalPais?: any;
  DireccionFiscalProvinciaId?: any;
  Door?: string;
  EsDireccionFiscalDiferente?: boolean;
  ExtraDetails?: string;
  Floor?: string;
  HomeId?: any;
  Number?: string;
  PostalCode?: string;
  ProvincePersonal?: any;
  Stair?: string;
  State?: string;
  Street?: string;
  StreetType?: string;
  TaxResidence?: any;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('MailResidenceEditClient')
export class MailResidence {
  City?: string;
  CityOfBirth?: any;
  Country?: string;
  CountryPersonal?: any;
  DireccionFiscal?: any;
  DireccionFiscalCiudad?: any;
  DireccionFiscalPais?: any;
  DireccionFiscalProvinciaId?: any;
  Door?: string;
  EsDireccionFiscalDiferente?: boolean;
  ExtraDetails?: string;
  Floor?: string;
  HomeId?: any;
  Number?: string;
  PostalCode?: string;
  ProvincePersonal?: any;
  Stair?: string;
  State?: string;
  Street?: string;
  StreetType?: string;
  TaxResidence?: any;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('PerformancePublicDutieseditClient')
export class PerformancePublicDuties {
  ImportantPublicDuties?: string;
  IsImportantPublicDuties?: any;
  IsImportantPublicDutiesRelative?: any;
  PublicDutieEndDate?: string;
  PublicDutieName?: any;
  RelativeRelationship?: any[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('EmployerAddressEditClient')
export class EmployerAddress {
  City?: string;
  CityOfBirth?: any;
  Country?: string;
  CountryPersonal?: any;
  DireccionFiscal?: any;
  DireccionFiscalCiudad?: any;
  DireccionFiscalPais?: any;
  DireccionFiscalProvinciaId?: any;
  Door?: any;
  EsDireccionFiscalDiferente?: boolean;
  ExtraDetails?: any;
  Floor?: any;
  HomeId?: any;
  Number?: any;
  PostalCode?: string;
  ProvincePersonal?: any;
  Stair?: any;
  State?: string;
  Street?: string;
  StreetType?: any;
  TaxResidence?: any;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('RegulatoryDeclarationEditClient')
export class RegulatoryDeclaration {
  Active?: string;
  AffiliationRelationship?: string;
  City?: string;
  Company?: string;
  CompanyEmail?: string;
  CompanyPhone?: string;
  Country?: string;
  Detail?: string;
  PersonName?: string;
  PostalCode?: string;
  RegulatoryType?: string;
  State?: string;
  Street?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('SourceOfIncomeEditClient')
export class SourceOfIncome {
  Description?: string;
  IsUsedForFunds?: string;
  Percentage?: number;
  Code?: string;
  SourceType?: string;
  Frequency?: number;
  PaymentMethod?: number;
  Country?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('ProfessionalDataEditClient')
export class ProfessionalData {
  AdditionalActivitiesInfo?: string;
  AnnualNetIncome?: string;
  CNAE?: any;
  CompanyActivity?: string;
  CompanyName?: string;
  ContractualStartDate?: string;
  EmployerAddress?: EmployerAddress;
  EmployerBusinessType?: string;
  EmployerBusinessTypeOther?: string;
  EmployerName?: string;
  EmploymentSituation?: string;
  EstimatedPositionKYC?: any;
  IsMultiplesActivities?: any;
  LiquidNetWorth?: string;
  NetWorth?: string;
  NumberOfTransactionsKYC?: any;
  NumberOfTransfersKYC?: any;
  Objective?: string[];
  Position?: string;
  PositionDescripcion?: any;
  PositionIB?: string;
  PositionIBOther?: string;
  PreviousPosition?: any;
  PreviousPositionIndicator?: boolean;
  PurposeKYC?: any;
  ReasonEmploymentDifferentCountry?: string;
  StartDateInTheCompany?: string;
  RegulatoryDeclarations?: RegulatoryDeclaration[];
  SourceOfFunds?: string;
  SourceOfFundsFreeText?: string;
  SourceOfIncomeFreeText?: string;
  SourceOfIncomes?: SourceOfIncome[];
  YearlyOutcomeRankId?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('TaxResidenceEditClient')
export class TaxResidence {
  FiscalPurposesCountries?: any[];
  IsOtherCountryPersonFiscalPurposes?: any;
  IsUSPersonFiscalPurposes?: any;
  TINNumber?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('W8BenEditClient')
export class W8Ben {
  blank_form?: string;
  cert?: string;
  customer_type?: any;
  explanation?: any;
  foreign_tax_id?: string;
  name?: string;
  part_2_9a_country?: string;
  proprietary_form_number?: string;
  signature_type?: any;
  tax_form_file?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Documents')
export class Documents {
  Base64?: string;
  TypeId?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
